import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'
import api from 'api'

const CREATE_REQUEST = 'realhub/brandGroupMember/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/brandGroupMember/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/brandGroupMember/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/brandGroupMember/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/brandGroupMember/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/brandGroupMember/DELETE_FAILURE'
const UPDATE_REQUEST = 'realhub/brandGroupMember/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/brandGroupMember/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/brandGroupMember/UPDATE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload = {}){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createBrandGroupMember(brandGroupMember, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      brand_group_member: brandGroupMember,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/brand_groups/${brandGroupMember.brand_group_id}/members.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().brandGroupMembers.result ? getState().brandGroupMembers.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_GROUP_MEMBER)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteBrandGroupMember(member, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/brand_groups/${member.brand_group_id}/members/${member.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Remove from result array
        const resultArray = getState().brandGroupMembers.result ? getState().brandGroupMembers.result.slice() : []
        const index = resultArray.indexOf(json.id)
        if (!resultArray.includes(json.id)){
          resultArray.splice(index, 1)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_GROUP_MEMBER)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })

    return promise
  }
}

export function setAdminGroupMember(member, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      brand_group_member_id: member.id,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/brand_groups/${member.brand_group_id}/set_admin.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_GROUP)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        result: action.result,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
